export enum FeatureFlags {
  PRIVATE_WORKSPACE = 'settings.app.private-workspace',
  ELEMENT_CONFIGURATION = 'common.app.element-config',
  DISABLE_SUBSCRIPTIONS = 'settings.app.disable-subscriptions',
  RADAR = 'explorer.app.radar',
  PORTFOLIO = 'explorer.app.portfolio',
  BOARD = 'explorer.app.board',
  WATCH_ELEMENTS = 'explorer.app.watch-elements',
  INSIGHTS = 'insights.app',
  INSIGHTS_ENABLED = 'insights.app.enabled',
  NETWORK_GRAPH = 'explorer.app.network',
  ROADMAP = 'roadmap.app',
  IDEATION = 'explorer.app.ideation',
  EMBED = 'common.app.embed',
  EXTERNAL_INTEGRATION = 'common.app.external-integration',
  PERMISSION_CONFIGURATION = 'settings.app.permission-configuration',
  POLICY_CONFIGURATION = 'common.app.policy-configuration',
  SSO = 'common.auth.sso',
  NOTIFICATION = 'settings.app.notification',
  SPACES_V2 = 'common.spaces.new',
  FILES_V2 = 'common.files.new',
  ADD_MULTIPLE_USER = 'settings.app.add-multiple-user-to-workspace',
  WORKSPACE_LEVEL_ELEMENT_CONFIG = 'settings.app.new-element-config',
  COMMON_ELEMENT_CONFIG = 'common.*.new-element-config',
  EXACT_RATING = 'common.app.exact-rating',
  TENANT_INVITE = 'settings.tenant-invite.workspace-roles',
  IMPORT_FEATURE_FLAG = 'common.*.import',
  EXPORT_FEATURE_FLAG = 'common.*.export-excel',
  ELEMENT_CONFIG_CUSTOM_TYPE_FEATURE_FLAG = 'common.app.element-config-custom-types',
  OPENSEARCH = 'common.lambda.opensearch',
  EXTERNAL_REPORTS = 'external-reports.app',
  MANAGE_RATINGS_FEATURE_FLAG = 'explorer.app.manage-ratings',
  AGGREGATED_RATING = 'common.*.aggregated-rating',
  ELEMENT_TYPE_PERMISSIONS = 'common.*.element-type-permissions',
  RATING_NOTES_FEATURE_FLAG = 'common.app.rating-notes',
  CONVERT_ELEMENT = 'common.app.convert-element',
  LIKE_ELEMENT = 'common.app.like-element',
  ELEMENTS_WORKFLOW = 'workflow.*.for-elements',
  POWERPOINT_EXPORT = 'common.*.export-powerpoint'
}
